/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'owlcarousel-v1';

if (
  $('.owl-carousel').length > 0 ||
  $('.js-step-carousel').length > 0 ||
  $('.owl-carousel3').length > 0 ||
  $('.owl-carousel-related-products').length > 0 ||
  $('.owl-carousel-jss').length > 0 ||
  $('.owl-carousel-vid-pager').length > 0 ||
  $('.owl-carousel-img-pager').length > 0
) {
  $('.owl-carousel').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    lazyLoad: true,
    autoHeight: true,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    singleItem: true,
  });

  $('.owl-carousel3').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    lazyLoad: true,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    items: 3,
    itemsDesktop: [1199, 3],
    itemsDesktopSmall: [979, 2],
    itemsMobile: [479, 1],
  });

  $('.owl-carousel-related-products').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    lazyLoad: true,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    items: 2,
    itemsDesktop: [1199, 2],
    itemsDesktopSmall: [979, 2],
    itemsMobile: [479, 1],
  });

  $(window).load(() => {
    let relatedHeight = 395;

    $('.owl-carousel-related-products .item').each(function() {
      if ($(this).height() > relatedHeight) {
        relatedHeight = $(this).height();
      }
    });
    $('.owl-carousel-related-products .related-product-item').each(function() {
      $(this).height(relatedHeight - 30);
    });
  });

  $('.owl-carousel-jss').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    lazyLoad: true,
    autoHeight: true,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    singleItem: true,
  });

  $('.owl-carousel-jss-news').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    lazyLoad: true,
    autoHeight: true,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    singleItem: true,
  });
  $('.owl-carousel-quote').owlCarousel({
    navigation: false, // Show next and prev buttons
    pagination: false,
    autoPlay: true,
    stopOnHover: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoHeight: true,
    singleItem: true,
  });

  $('.owl-carousel-vid-pager').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    items: 3,
    itemsDesktop: [1199, 3],
    itemsDesktopSmall: [979, 2],
    itemsMobile: [479, 2],
  });

  const $nextCrousel = $('.js-step-carousel');
  $nextCrousel.owlCarousel({
    mouseDrag: false,
    touchDrag: false,
    navigation: false,
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    transitionStyle: 'backSlide',
    items: 1,
    itemsDesktop: [1199, 1],
    itemsDesktopSmall: [979, 1],
    itemsMobile: [479, 1],
  });

  $('.js-btn-next').click(event => {
    $(event.currentTarget)
      .closest($nextCrousel)
      .trigger('owl.next');
    event.preventDefault();
  });

  $('.owl-carousel-img-pager').owlCarousel({
    navigation: true, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    navigationText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
    transitionStyle: 'backSlide',
    items: 3,
    itemsDesktop: [1199, 3],
    itemsDesktopSmall: [979, 2],
    itemsMobile: [479, 2],
  });
}
